<template>
<div class="move">
	<van-nav-bar :title="this.videoInfo.vod_name" >
	  <template #left>
	    <van-icon name="arrow-left" color="#fff" @click="back()"/>
	  </template>
	</van-nav-bar>
	
	<!-- 播放器部分 -->
	<div class="movie-video">
	  <d-player ref="player" id="player" @play="handlePlay" @pause="handlePause" :options="options" v-if="videoType !== 'hls'"></d-player>
	  
	  <div v-if="videoType === 'hls'" class="hls-player-container">
	    <video id="hls-player" class="video-js vjs-default-skin" controls preload="auto" width="100%" height="100%" :poster="videoInfo.vod_pic">
	      <p class="vjs-no-js">
	        要查看此视频，请启用JavaScript，并考虑升级到
	        <a href="https://videojs.com/html5-video-support/" target="_blank">支持HTML5视频的Web浏览器</a>。
	      </p>
	    </video>
	  </div>
	  
	  <!-- 试看提示 -->
	  <div v-if="showTrialWarning" class="trial-warning">
        <div class="trial-message">
          <van-icon name="warning" class="warning-icon" />
          <p>试看剩余时间: {{ Math.ceil(trialTimeLeft) }}秒</p>
        </div>
      </div>
	</div>
	
	<!-- 试看结束提示弹窗 -->
	<van-dialog
	  v-model="showBalanceDialog"
	  :title="$t('video.trialEnded')"
	  :confirm-button-text="$t('video.goRecharge')"
	  @confirm="goRecharge"
	>
	  <div class="trial-end-dialog">
	    <p>{{ $t('video.rechargeToWatch') }}</p>
	  </div>
	</van-dialog>
	
	<div class="title">
		<p>
			{{ this.videoInfo.vod_name}}
		</p>
		<span>
			{{this.videoInfo.count}}{{$t('video.bofangliang')}}
		</span>
	</div>
	<div class="item">
		<div class="title">
			<span>
				<i>
					<img src="data:image/png;base64,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"
					alt="">
				</i>
				{{$t('video.hotlist')}}
			</span>
		</div>		
		<div class="van-pull-refresh">
			<div class="van-pull-refresh__track" style="transition-duration: 0ms;">
				<div class="van-pull-refresh__head"></div>
				<div role="feed" class="van-list" aria-busy="true">
					<ul class="hot">
						<li  @click="toPlayVideo(v.id)" v-for="(v,key) in displayedVideos" :key="key">
							<img :src="v.vod_pic" alt="">
							<div>
								<span>
									{{ v.vod_name }}
								</span>
								<span>
									{{$t('video.bofangliang')}}:{{ v.count }}
								</span>
							</div>
						</li>						
					</ul>
					
					<!-- 加载更多按钮 -->
					<div class="load-more-btn" v-if="hasMore">
						<van-button 
							:loading="loadingMore" 
							loading-text="加载中..."
							@click="loadMore"
							round
							block
							class="load-btn"
						>
							<template #default>
								<van-icon name="arrow-down" class="load-icon" />
								<!-- 去掉文字，只保留箭头 -->
							</template>
						</van-button>
					</div>
					
					<!-- 没有更多数据 -->
					<div class="no-more" v-if="!hasMore && moreVideoInfo.length > 0">
						<van-icon name="checked" class="checked-icon" />
						{{$t('common.noMore')}}
					</div>
					
					<div class="van-list__placeholder"></div>
				</div>
			</div>
		</div>
	</div>
</div>
</template>

<script>
import videojs from "video.js";
import "videojs-contrib-hls";
import cacheManager from '../../common/cache';

export default {
  data() {
    return {
      nowPlayVideoUrl: "",
      cover:"",
      userInfo:[],
      videoInfo:{},
      moreVideoInfo:[], // 所有视频数据
      displayedVideos: [], // 当前显示的视频数据
      player:null,
      videoType: 'auto',
      progressTimer: null,
      progressInitialized: false,
      savedProgress: 0,
      is_zz: false,
      
      // 余额检查和试看相关
      userBalance: 0,
      showBalanceDialog: false,
      showTrialWarning: false,
      trialTimeLeft: 60, // 试看时间60秒
      trialTimer: null,
      isTrialMode: false,
      trialEnded: false,
      
      // 分页相关数据
      currentDisplayCount: 10, // 当前显示数量
      loadMoreCount: 10, // 每次加载数量
      hasMore: true,
      loadingMore: false,
      
	  options: {
	    container: document.getElementById("dplayer"),
	    mutex: false,
	    theme: "#3498db",
	    loop: false,
	  	autoplay:false,
	    lang: "zh-cn",
	    screenshot: true,
	    hotkey: true,
	    preload: "auto",
	    volume: 0.7,
	    playbackSpeed: [0.5, 0.75, 1, 1.25, 1.5, 2, 3],
	    logo:"",
	    video: {
	      url:'',
	      pic:"",
	      thumbnails:""
	    },
	  }
    };
  },
  mounted() {
    this.getVideoInfo();
    this.getMoreVideoItem();
    this.getUserInfo();
  },
  beforeDestroy() {
    this.stopProgressMonitoring();
    this.stopTrialTimer();
    
    if (this.player) {
      try {
        if (typeof this.player.destroy === 'function') {
          this.player.destroy();
        } else if (typeof this.player.dispose === 'function') {
          this.player.dispose();
        }
      } catch (error) {
        console.error('播放器销毁失败:', error);
      }
      this.player = null;
    }
    
    this.progressInitialized = false;
  },
  methods: {
    back(){
      this.$router.push({path:'Video'})
    },
    
    // 加载更多数据
    loadMore() {
      if (this.loadingMore || !this.hasMore) return;
      
      this.loadingMore = true;
      
      // 模拟加载延迟
      setTimeout(() => {
        this.currentDisplayCount += this.loadMoreCount;
        
        // 更新显示的视频列表
        this.displayedVideos = this.moreVideoInfo.slice(0, this.currentDisplayCount);
        
        // 检查是否还有更多数据
        if (this.currentDisplayCount >= this.moreVideoInfo.length) {
          this.hasMore = false;
        }
        
        this.loadingMore = false;
      }, 500);
    },
    
    getVideoInfo(){
      const videoId = this.$route.query.id;
      const cacheKey = `video_info_${videoId}`;
      
      const cachedData = cacheManager.get(cacheKey);
      if (cachedData) {
        console.log('使用缓存的视频信息');
        this.videoInfo = cachedData;
        this.nowPlayVideoUrl = this.videoInfo.vod_play_url;
        this.videoType = this.detectVideoType(this.nowPlayVideoUrl);
        
        this.options.video.pic = this.videoInfo.vod_pic;
        this.options.video.url = this.videoInfo.vod_play_url;
        
        this.initPlayer();
        
        this.$nextTick(() => {
          this.initWatchProgress();
        });
        return;
      }
      
      this.$http({
        method: 'get',
        data:{id:videoId},
        url: 'video_get_info'
      }).then(res=>{
        this.videoInfo = res.data;
        this.nowPlayVideoUrl = this.videoInfo.vod_play_url;
        this.videoType = this.detectVideoType(this.nowPlayVideoUrl);
        
        cacheManager.set(cacheKey, res.data, 60 * 1000);
        
		this.options.video.pic = this.videoInfo.vod_pic;
		this.options.video.url = this.videoInfo.vod_play_url;
        
        this.initPlayer();
        
        this.$nextTick(() => {
		  const bezel = document.querySelector(".dplayer-bezel");
		  if(bezel) {
		    bezel.style.backgroundImage = 'url("'+this.videoInfo.vod_pic+'")';
		    bezel.style.backgroundRepeat = 'no-repeat';
		    bezel.style.backgroundSize = 'cover';
		  }
		  
		  this.initWatchProgress();
		});
      })
    },
    
    // 获取更多视频的方法
    getMoreVideoItem(){
      this.loadingMore = false;
      this.hasMore = true;
      this.currentDisplayCount = 10; // 重置为显示10个
      
      this.$http({
        method: 'get',
        url: 'video_get_more_item'
      }).then(res=>{
        this.moreVideoInfo = res.data || [];
        
        // 初始只显示前10个
        this.displayedVideos = this.moreVideoInfo.slice(0, this.currentDisplayCount);
        
        // 检查是否还有更多数据
        if (this.currentDisplayCount >= this.moreVideoInfo.length) {
          this.hasMore = false;
        } else {
          this.hasMore = true;
        }
      }).catch(error => {
        console.error('获取视频列表失败:', error);
        this.hasMore = false;
      });
    },
    
    detectVideoType(url) {
      if (!url) return 'unknown';
      const lowerUrl = url.toLowerCase();
      if (lowerUrl.includes('.m3u8') || lowerUrl.includes('m3u8')) {
        return 'hls';
      }
      if (lowerUrl.includes('.mp4') || lowerUrl.includes('mp4')) {
        return 'mp4';
      }
      if (lowerUrl.includes('.webm') || lowerUrl.includes('webm')) {
        return 'webm';
      }
      if (lowerUrl.includes('.ogv') || lowerUrl.includes('ogv')) {
        return 'ogg';
      }
      if (lowerUrl.includes('rtmp://') || lowerUrl.includes('rtsp://')) {
        return 'stream';
      }
      return 'auto';
    },
    
    initPlayer() {
      try {
        if (this.player) {
          if (typeof this.player.destroy === 'function') {
            this.player.destroy();
          } else if (typeof this.player.dispose === 'function') {
            this.player.dispose();
          }
          this.player = null;
        }
        
        if (this.videoType === 'hls') {
          this.initHLSPlayer();
        } else {
          this.initDPlayer();
        }
      } catch (error) {
        console.error('播放器初始化失败:', error);
        this.initDPlayer();
      }
    },
    
    initHLSPlayer() {
      this.$nextTick(() => {
        const playerContainer = document.querySelector('.movie-video');
        if (!playerContainer) {
          console.error('播放器容器不存在');
          return;
        }
        
        playerContainer.innerHTML = `
          <video id="hls-player" class="video-js vjs-default-skin" controls preload="auto" width="100%" height="100%" poster="${this.videoInfo.vod_pic || ''}">
            <p class="vjs-no-js">
              要查看此视频，请启用JavaScript，并考虑升级到
              <a href="https://videojs.com/html5-video-support/" target="_blank">支持HTML5视频的Web浏览器</a>。
            </p>
          </video>
        `;
        
        setTimeout(() => {
          try {
            this.player = videojs('hls-player', {
              controls: true,
              preload: 'auto',
              fluid: true,
              responsive: true,
              width: '100%',
              playbackRates: [0.5, 0.75, 1, 1.25, 1.5, 2],
              html5: {
                hls: {
                  enableLowInitialPlaylist: true,
                  smoothQualityChange: true,
                  overrideNative: true
                }
              }
            });
        
            console.log('设置HLS视频源:', this.nowPlayVideoUrl);
            this.player.src({
              src: this.nowPlayVideoUrl,
              type: 'application/x-mpegURL'
            });
            
            this.player.on('loadedmetadata', () => {
              console.log('HLS视频元数据加载完成');
              setTimeout(() => {
                if (this.savedProgress > 0) {
                  console.log('HLS(metadata)跳转到保存的进度:', this.savedProgress);
                  this.seekToProgress(this.savedProgress);
                  this.savedProgress = 0;
                }
              }, 300);
            });
            
            this.player.on('play', () => {
              console.log('HLS播放器开始播放');
              this.handlePlay();
            });
            
            this.player.on('pause', () => {
              console.log('HLS播放器暂停');
              this.handlePause();
            });
            
            this.player.on('error', (error) => {
              console.error('HLS播放器错误:', error);
              this.initDPlayer();
            });
          } catch (error) {
            console.error('HLS播放器初始化失败:', error);
            this.initDPlayer();
          }
        }, 100);
      });
    },
    
    initDPlayer() {
      this.$nextTick(() => {
        const playerContainer = document.querySelector('.movie-video');
        if (playerContainer) {
          playerContainer.innerHTML = '<div id="player"></div>';
          
          setTimeout(() => {
            try {
              import('dplayer').then(DPlayer => {
                this.player = new DPlayer.default({
                  container: document.getElementById('player'),
                  video: {
                    url: this.videoInfo.vod_play_url,
                    pic: this.videoInfo.vod_pic
                  },
                  autoplay: false,
                  theme: '#3498db',
                  loop: false,
                  lang: 'zh-cn'
                });
                
                this.player.on('play', () => {
                  console.log('DPlayer播放');
                  this.handlePlay();
                });
                
                this.player.on('pause', () => {
                  console.log('DPlayer暂停');
                  this.handlePause();
                });
                
                console.log('DPlayer初始化成功');
                
                if (this.player.video && !this.player.video.paused) {
                  console.log('视频已在播放，立即开始进度监控');
                  this.handlePlay();
                }
                
                this.player.on('canplay', () => {
                  console.log('DPlayer视频可以播放');
                  setTimeout(() => {
                    if (this.savedProgress > 0) {
                      console.log('DPlayer跳转到保存的进度:', this.savedProgress);
                      this.seekToProgress(this.savedProgress);
                      this.savedProgress = 0;
                    }
                  }, 500);
                  
                  if (this.is_zz && !this.progressTimer) {
                    console.log('视频可播放，启动进度监控');
                    this.startProgressMonitoring();
                  }
                });
                
                this.player.on('loadedmetadata', () => {
                  console.log('DPlayer视频元数据加载完成');
                  setTimeout(() => {
                    if (this.savedProgress > 0) {
                      console.log('DPlayer(metadata)跳转到保存的进度:', this.savedProgress);
                      this.seekToProgress(this.savedProgress);
                      this.savedProgress = 0;
                    }
                  }, 300);
                });
              }).catch(error => {
                console.error('DPlayer加载失败:', error);
              });
            } catch (error) {
              console.error('DPlayer初始化失败:', error);
            }
          }, 100);
        }
      });
    },

	handlePlay(){
	  console.log('播放');
	  this.is_zz=true;
	  
	  // 检查余额并决定是否启用试看模式
	  this.checkBalanceAndStartTrial();
	  
	  if (this.player && this.player.video) {
	    console.log('播放器对象存在，开始初始化观看进度');
	    this.initWatchProgress();
	  } else {
	    console.log('播放器对象不存在，延迟初始化');
	    setTimeout(() => {
	      this.initWatchProgress();
	    }, 1000);
	  }
	},
	
	handlePause(){
	  console.log('暂停');
	  this.stopTrialTimer();
	},
	
	// 检查余额并启动试看模式
	checkBalanceAndStartTrial() {
	  if (this.userBalance <= 0) {
	    console.log('余额不足，启用试看模式');
	    this.isTrialMode = true;
	    this.showTrialWarning = true;
	    this.startTrialTimer();
	  } else {
	    console.log('余额充足，正常观看');
	    this.isTrialMode = false;
	    this.showTrialWarning = false;
	    this.stopTrialTimer();
	  }
	},
	
	// 启动试看计时器
	startTrialTimer() {
	  this.trialTimeLeft = 60; // 重置试看时间为60秒
	  this.trialEnded = false;
	  
	  this.trialTimer = setInterval(() => {
	    this.trialTimeLeft--;
	    
	    if (this.trialTimeLeft <= 0) {
	      this.endTrial();
	    }
	  }, 1000);
	},
	
	// 停止试看计时器
	stopTrialTimer() {
	  if (this.trialTimer) {
	    clearInterval(this.trialTimer);
	    this.trialTimer = null;
	  }
	},
	
	// 结束试看
	endTrial() {
	  this.stopTrialTimer();
	  this.trialEnded = true;
	  this.showTrialWarning = false;
	  
	  // 暂停播放
	  if (this.player) {
	    if (this.player.pause) {
	      this.player.pause();
	    } else if (this.player.video && this.player.video.pause) {
	      this.player.video.pause();
	    }
	  }
	  
	  // 显示试看结束弹窗
	  this.showBalanceDialog = true;
	},
	
	// 跳转到充值页面
	goRecharge() {
	  this.$router.push('/Recharge');
	},
	
    toPlayVideo(id){
      if(!localStorage.getItem('token')){
        this.$router.push({path:'/Home'})
      }else {
        this.$router.push({path:'?id='+id})
        location.reload();
      }
    },
    
    getUserInfo(){
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res=>{
        if(res.code === 200){
          this.userInfo = res.data;
          this.userBalance = parseFloat(this.userInfo.money || 0);
          
          if(this.userInfo.status !== 1){
            this.$toast(this.$t('accountOffline'));
            localStorage.clear()
            this.$router.push({path:'/Home'})
          } else {
            // 移除余额检查，允许进入播放页面
            this.getVideoInfo();
            this.getMoreVideoItem();
          }
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
    
    recordWatchHistory(){
      if(!this.videoInfo || !this.videoInfo.api_vod_id){
        return;
      }
      
      let currentTime = 0;
      let duration = 0;
      
      if(this.player && this.player.video){
        currentTime = this.player.video.currentTime || 0;
        duration = this.player.video.duration || 0;
      }
      
      const percentage = duration > 0 ? (currentTime / duration) * 100 : 0;
      
      console.log(`记录观看历史: API视频ID=${this.videoInfo.api_vod_id}, 进度=${Math.floor(currentTime)}秒 (${percentage.toFixed(2)}%)`);
      
      this.$http({
        method: 'post',
        data: {
          video_id: this.videoInfo.api_vod_id,
          watch_progress: Math.floor(currentTime),
          watch_percentage: parseFloat(percentage.toFixed(2))
        },
        url: 'video_record_watch'
      }).then(res=>{
        console.log('观看记录保存结果:', res);
        if(res.code !== 200){
          console.error('观看记录保存失败:', res.msg);
        }
      }).catch(error=>{
        console.error('保存观看记录失败:', error);
      });
    },
    
    initWatchProgress(){
      if(!this.videoInfo || !this.videoInfo.api_vod_id){
        console.log('初始化观看进度失败: 缺少视频信息或API视频ID');
        return;
      }
      
      console.log('开始初始化观看进度');
      
      this.progressInitialized = false;
      
      this.recordWatchHistory();
      
      this.getWatchProgress().then(() => {
        this.progressInitialized = true;
        console.log('观看进度初始化完成，准备开始监控');
        setTimeout(() => {
          this.startProgressMonitoring();
        }, 2000);
      }).catch(() => {
        this.progressInitialized = true;
        console.log('观看进度初始化完成（获取失败），准备开始监控');
        setTimeout(() => {
          this.startProgressMonitoring();
        }, 2000);
      });
    },
    
    startProgressMonitoring(){
      if(!this.videoInfo || !this.videoInfo.api_vod_id){
        console.log('进度监控启动失败: 缺少视频信息或API视频ID');
        return;
      }
      
      console.log('开始进度监控，每5秒记录一次');
      
      this.progressTimer = setInterval(() => {
        let isPlaying = false;
        
        if(this.player && this.player.video){
          isPlaying = !this.player.video.paused;
        } else {
          const allVideos = document.querySelectorAll('video');
          for (let video of allVideos) {
            if (video.duration > 0) {
              isPlaying = !video.paused;
              break;
            }
          }
        }
        
        if(isPlaying){
          this.updateWatchProgress();
        } else {
          console.log('播放器已暂停，跳过进度更新');
        }
      }, 5000);
    },
    
    stopProgressMonitoring(){
      if(this.progressTimer){
        clearInterval(this.progressTimer);
        this.progressTimer = null;
      }
    },
    
    getWatchProgress(){
      if(!this.videoInfo || !this.videoInfo.api_vod_id){
        console.log('获取观看进度失败: 缺少视频信息或API视频ID');
        return Promise.resolve();
      }
      
      console.log(`获取观看进度: API视频ID=${this.videoInfo.api_vod_id}`);
      
      return this.$http({
        method: 'get',
        data: {
          video_id: this.videoInfo.api_vod_id
        },
        url: 'video_get_progress'
      }).then(res=>{
        console.log('获取观看进度API响应:', res);
        
        if(res.code === 200 && res.data){
          if(res.data.watch_progress > 0){
            console.log('获取到观看进度:', res.data);
            this.savedProgress = res.data.watch_progress;
            console.log('保存进度信息，等待播放器准备好后跳转:', this.savedProgress);
          } else {
            console.log('观看进度为0，从头开始播放');
            this.savedProgress = 0;
          }
        } else {
          console.log('没有找到观看记录，从头开始播放');
          this.savedProgress = 0;
        }
        return res;
      }).catch(error=>{
        console.error('获取观看进度失败:', error);
        this.savedProgress = 0;
        return Promise.reject(error);
      });
    },
    
    updateWatchProgress(){
      console.log('updateWatchProgress被调用');
      console.log('视频信息:', this.videoInfo);
      console.log('进度初始化状态:', this.progressInitialized);
      console.log('播放器状态:', this.player);
      
      if(!this.videoInfo || !this.videoInfo.api_vod_id || !this.progressInitialized){
        console.log('更新进度被跳过: 缺少必要信息或未初始化');
        return;
      }
      
      let currentTime = 0;
      let duration = 0;
      let progressSource = '';
      
      if(this.player && this.player.video){
        currentTime = this.player.video.currentTime || 0;
        duration = this.player.video.duration || 0;
        progressSource = 'DPlayer.video';
        console.log('通过this.player.video获取进度:', { currentTime, duration, source: progressSource });
      }
      else if(document.getElementById('player')){
        const playerElement = document.getElementById('player');
        const videoElement = playerElement.querySelector('video');
        if(videoElement){
          currentTime = videoElement.currentTime || 0;
          duration = videoElement.duration || 0;
          progressSource = 'DOM video element';
          console.log('通过DPlayer video元素获取进度:', { currentTime, duration, source: progressSource });
        }
      }
      else if(document.getElementById('hls-player')){
        const hlsPlayer = document.getElementById('hls-player');
        if(hlsPlayer){
          currentTime = hlsPlayer.currentTime || 0;
          duration = hlsPlayer.duration || 0;
          progressSource = 'HLS player';
          console.log('通过HLS播放器获取进度:', { currentTime, duration, source: progressSource });
        }
      }
      else if(this.player && this.player.currentTime){
        currentTime = this.player.currentTime() || 0;
        duration = this.player.duration() || 0;
        progressSource = 'video.js player';
        console.log('通过video.js播放器获取进度:', { currentTime, duration, source: progressSource });
      }
      
      if (currentTime === 0 && duration === 0) {
        const allVideos = document.querySelectorAll('video');
        for (let video of allVideos) {
          if (video.currentTime > 0 || video.duration > 0) {
            currentTime = video.currentTime || 0;
            duration = video.duration || 0;
            progressSource = 'global video search';
            console.log('通过全局video搜索获取进度:', { currentTime, duration, source: progressSource });
            break;
          }
        }
      }
      
      if(duration > 0){
        const percentage = (currentTime / duration) * 100;
        
        console.log(`更新观看进度: API视频ID=${this.videoInfo.api_vod_id}, ${Math.floor(currentTime)}秒 (${percentage.toFixed(2)}%), 来源=${progressSource}`);
        
        this.$http({
          method: 'post',
          data: {
            video_id: this.videoInfo.api_vod_id,
            watch_progress: Math.floor(currentTime),
            watch_percentage: parseFloat(percentage.toFixed(2))
          },
          url: 'video_update_progress'
        }).then(res=>{
          console.log('观看进度更新成功:', res);
        }).catch(error=>{
          console.error('更新观看进度失败:', error);
        });
      } else {
        console.log('视频时长无效，跳过进度更新。当前时长:', duration, '来源:', progressSource);
      }
    },
    
    // 跳转到指定进度
    seekToProgress(progress, retryCount = 0){
      if(progress <= 0) {
        console.log('进度为0，跳过跳转');
        return;
      }
      
      const maxRetries = 3;
      console.log(`尝试跳转到观看进度: ${progress}秒 (重试次数: ${retryCount}/${maxRetries})`);
      
      // 方式1: 通过DPlayer
      if(this.player && this.player.video){
        try {
          this.player.video.currentTime = progress;
          console.log('通过DPlayer跳转到观看进度:', progress + '秒');
          return;
        } catch (e) {
          console.error('DPlayer跳转失败:', e);
        }
      }
      
      // 方式2: 通过DOM video元素
      const playerElement = document.getElementById('player');
      if(playerElement){
        const videoElement = playerElement.querySelector('video');
        if(videoElement){
          try {
            videoElement.currentTime = progress;
            console.log('通过DOM video元素跳转到观看进度:', progress + '秒');
            return;
          } catch (e) {
            console.error('DOM video跳转失败:', e);
          }
        }
      }
      
      // 方式3: 通过HLS播放器
      const hlsPlayer = document.getElementById('hls-player');
      if(hlsPlayer){
        try {
          hlsPlayer.currentTime = progress;
          console.log('通过HLS播放器跳转到观看进度:', progress + '秒');
          return;
        } catch (e) {
          console.error('HLS播放器跳转失败:', e);
        }
      }
      
      // 方式4: 通过video.js播放器
      if(this.player && this.player.currentTime){
        try {
          this.player.currentTime(progress);
          console.log('通过video.js播放器跳转到观看进度:', progress + '秒');
          return;
        } catch (e) {
          console.error('video.js跳转失败:', e);
        }
      }
      
      // 方式5: 全局查找video元素
      const allVideos = document.querySelectorAll('video');
      console.log('找到video元素数量:', allVideos.length);
      for (let i = 0; i < allVideos.length; i++) {
        const video = allVideos[i];
        console.log(`video[${i}] duration:`, video.duration, 'readyState:', video.readyState);
        if (video.duration > 0) {
          try {
            video.currentTime = progress;
            console.log('通过全局video搜索跳转到观看进度:', progress + '秒');
            return;
          } catch (e) {
            console.error('全局video跳转失败:', e);
          }
        }
      }
      
      console.log('无法找到可用的播放器来跳转进度');
      
      // 如果跳转失败且还有重试次数，延迟重试
      if (retryCount < maxRetries) {
        console.log(`跳转失败，${1000 * (retryCount + 1)}ms后重试`);
        setTimeout(() => {
          this.seekToProgress(progress, retryCount + 1);
        }, 1000 * (retryCount + 1));
      } else {
        console.error('进度跳转失败，已达到最大重试次数');
      }
    }
  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/Home'})
    }else {
      this.getUserInfo();
    }
  },
  destroyed () {
    this.stopProgressMonitoring();
    this.stopTrialTimer();
    
    if (this.player) {
      try {
        if (this.player.dispose && typeof this.player.dispose === 'function') {
          this.player.dispose();
        }
      } catch (e) {
        console.error('播放器销毁失败:', e);
      }
    }
  }
};
</script>

<style scoped>
/* 修改所有渐变色为 #3498db 到 #8e44ad */
:export {
    gbcolor: linear-gradient(30deg, #3498db, #8e44ad)
}

.move .van-popup--top .box .title {
    background: linear-gradient(30deg, #3498db, #8e44ad);
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #fff;
    padding: 4% 5%
}

.move .van-popup--top .box .content a {
    background: linear-gradient(90deg, #3498db, #8e44ad);
    color: #fff;
    padding: 10px 20px;
    border-radius: 90px;
    font-size: 12px
}

.move>.title p {
    font-weight: 600;
    color: #3498db;
    font-size: .93333rem;
    margin-bottom: .5rem
}

.move>.title span {
    color: #8e44ad;
    font-size: .8rem;
    background: #f2f2f5;
    padding: .33333rem .6rem;
    border-radius: .33333rem
}

.move .item>.title span {
    font-weight: 600;
    display: flex;
	font-size: 1rem;
    justify-content: flex-start;
    align-items: center;
    color: #3498db
}

/* 试看警告样式 */
.trial-warning {
  position: absolute;
  top: 10px;
  left: 0;
  right: 0;
  z-index: 1000;
  display: flex;
  justify-content: center;
  padding: 0 20px;
}

.trial-message {
  background: rgba(255, 193, 7, 0.9);
  color: #856404;
  padding: 8px 16px;
  border-radius: 20px;
  display: flex;
  align-items: center;
  font-size: 14px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.warning-icon {
  margin-right: 8px;
  font-size: 16px;
}

/* 修改试看结束弹窗样式 */
.trial-end-dialog {
  padding: 30px 20px;
  text-align: center;
}

.trial-end-dialog p {
  font-size: 30px;
  color: #ff0000;
  margin: 0;
  line-height: 1.5;
}

/* 添加弹窗边框圆角样式 */
:deep(.van-dialog) {
  border-radius: 16px !important;
  overflow: hidden;
}

:deep(.van-dialog__header) {
  padding-top: 20px;
  font-size: 18px;
  font-weight: 600;
}

:deep(.van-dialog__content) {
  border-radius: 0 0 16px 16px;
}

:deep(.van-dialog__footer) {
  border-radius: 0 0 16px 16px;
  overflow: hidden;
}

/* 加载更多按钮样式 */
.load-more-btn {
  width: 100%;
  padding: 20px 15px;
  text-align: center;
}

.load-btn {
  background: linear-gradient(90deg, #3498db, #8e44ad);
  color: #fff;
  border: none;
  height: 44px;
  font-size: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.load-icon {
  font-size: 20px;
}

.no-more {
  text-align: center;
  padding: 20px 0;
  color: #999;
  font-size: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.checked-icon {
  margin-right: 8px;
  color: #4caf50;
}

/* HLS播放器样式 */
.hls-player-container {
  width: 100%;
  background: #000;
  position: relative;
}

.hls-player-container .video-js {
  width: 100%;
  font-size: 24px;
}

.movie-video {
  width: 100%;
  background: #000;
  position: relative;
}

.movie-video .dplayer {
  width: 100%;
}

.move .d-player-video-main {
  width: 96%!important;
  height: auto!important
}

.move .d-player-wrap {
  height: auto
}

.van-nav-bar {
    z-index: 999;
    background: linear-gradient(30deg, #3498db, #8e44ad) !important;
    line-height: 2.2rem;
}

.van-nav-bar {
	position: relative;
    z-index: 999;
	height:3rem ;
	line-height: 3rem;
    background: linear-gradient(30deg, #3498db, #8e44ad) !important;
}
.van-nav-bar .van-icon,.van-nav-bar__title {
    color: #fff
}
.dplayer-bezel .dplayer-bezel-icon {
    position: absolute;
    top: 50%;
    left: 50%;
    margin: -3.467vw 0 0 -3.467vw;
    height: 16.933vw;
    width: 16.933vw;
    padding: 1.6vw;
    box-sizing: border-box;
    background: rgba(0,0,0,.5);
    border-radius: 50%;
    opacity: 0;
    pointer-events: none;
}

.video-js {
  width: 100%;
  font-size: 24px;
}

.hot {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    flex-wrap: wrap
}

.hot li {
    width: calc(50% - .33333rem);
    border-radius: .33333rem;
    overflow: hidden;
    margin-top: .66667rem;
    height: 6.66667rem;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center
}

.hot li img {
    height: 100%;
	width: 100%;
}

.hot li>div {
    position: absolute;
    width: 100%;
    bottom: 0;
    left: 0;
    background: rgba(0,0,0,.4);
    padding: .33333rem 0;
    display: flex;
    justify-content: space-between;
    align-items: center
}

.hot li>div span {
    color: #fff;
    font-size: .8rem;
    width: 50%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding: 0 .33333rem
}

.move {
    width: 100%;
    min-height: 100%;
    background: #f0f0f0
}

.move .van-popup--top {
    top: 0;
    bottom: 0;
    margin: auto;
    background: none;
    display: flex;
    justify-content: center;
    align-items: center
}

.move .van-popup--top .box {
    width: 90%;
    height: 200px;
    background: #fff;
    border-radius: 10px;
    overflow: hidden
}

.move .van-popup--top .box .title {
    background: linear-gradient(30deg, #3498db, #8e44ad);
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #fff;
    padding: 4% 5%
}

.move .van-popup--top .box .title p {
    font-size: 16px
}

.move .van-popup--top .box .title i {
    color: #fff
}

.move .van-popup--top .box .content h1 {
    font-size: 18px;
    padding: 30px 0
}

.move .van-popup--top .box .content a {
    background: linear-gradient(90deg, #3498db, #8e44ad);
    color: #fff;
    padding: 10px 20px;
    border-radius: 90px;
    font-size: 12px
}

.move .van-popup--top .box .content p {
    padding: 20px 0
}

.move .van-popup--top .box .content p span {
    color: #3498db
}

.move .d-player-video-main {
    width: 96%!important;
    height: auto!important
}

.move .d-player-wrap {
    height: auto
}

.move>.title {
    background: #fff;
    width: 100%;
    padding: .66667rem 3%;
    text-align: left
}

.move>.title> {
    padding: 0 0
}

.move>.title p {
    font-weight: 600;
    color: #3498db;
    font-size: .93333rem;
    margin-bottom: .5rem
}

.move>.title span {
    color: #8e44ad;
    font-size: .8rem;
    background: #f2f2f5;
    padding: .33333rem .6rem;
    border-radius: .33333rem
}

.move .item {
    width: 100%;
    padding: .66667rem
}

.move .item>.title {
    display: flex;
    justify-content: space-between;
    align-items: center
}

.move .item>.title span {
    font-weight: 600;
    display: flex;
	font-size: 1rem;
    justify-content: flex-start;
    align-items: center;
    color: #3498db
}

.move .item>.title span i {
    margin-right: .4rem
}

.move .item>.title span i img {
    width: 1.13333rem
}

.move .item>.title a {
    color: #979799
}

.poster {
    height: 13.33333rem;
    background: #000;
    position: relative
}

.poster>div,.poster {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center
}

.poster>div {
    position: absolute;
    height: 100%;
    left: 0;
    top: 0;
    background: rgba(0,0,0,.8)
}

.poster>div .van-loading {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center
}

.poster img {
    height: 100%
}

</style>